const URL_PATTERN = /^https?:\/\/[^\s/$.?#].[^\s]*$/;

export const SourceUrlErrors = {
    REQUIRED: 'URL is required',
    MISSING_SCHEME: 'URL must start with http:// or https://',
    INVALID: 'Please enter a valid URL',
};

export const validateSourceUrl = (url) => {
    if (!url?.trim()) {
        return SourceUrlErrors.REQUIRED;
    }

    const trimmedUrl = url.trim();
    if (!trimmedUrl.match(/^https?:\/\//)) {
        return SourceUrlErrors.MISSING_SCHEME;
    }

    if (!URL_PATTERN.test(trimmedUrl)) {
        return SourceUrlErrors.INVALID;
    }

    return '';
};
